<template>
    <div>
        <div class="font-weight-regular title mb-3 mt-3 ml-3" v-if="!page_title">&nbsp;&nbsp;&nbsp;&nbsp;</div>
        <div class="font-weight-regular title mb-3 mt-3 ml-3" v-if="page_title">{{ page_title }}</div>
        <v-divider></v-divider>
    </div>
</template>

<script>
    export default {
        
        props : ['page_title'],
        
    }
</script>